export default (price) => (Number.isInteger(price) ? `${price}.00` : price)
